import { scrollToPosition, scrollToElement } from './utils.js'

let $buttons = Array.from(document.querySelectorAll('.js-scroll-to'))

$buttons.forEach(init)

function init ($button) {
  $button.addEventListener('click', scrollTo)
}

function scrollTo (e) {
  e.preventDefault()

  let id = e.target
    .closest('.js-scroll-to')
    .getAttribute('href')
    .substr(1)

  if (id === '') {
    scrollToPosition(0)
    return
  }

  let $target = document.getElementById(id)
  scrollToElement($target)
}



// WEBPACK FOOTER //
// ./src/js/_scroll-to.js